import type { HttpConnectionSnapshot } from './httpConnection'

/** Own moves use HTTP. A socket drop alone never warrants a network notice. */
export const HTTP_CONNECTION_NOTICE_MS = 15_000
export const OFFLINE_MESSAGE = 'No network connection'

export function connectionBannerMessage({ offline, snapshot, now, foregroundAt }: {
  offline: boolean
  snapshot: HttpConnectionSnapshot
  now: number
  foregroundAt: number
}): string | null {
  if (offline) return OFFLINE_MESSAGE
  const starts = [snapshot.oldestRequestAt, snapshot.failureSince].filter((start): start is number => start !== null)
  if (!starts.length || now - Math.max(Math.min(...starts), foregroundAt) < HTTP_CONNECTION_NOTICE_MS) return null
  return snapshot.failureSince !== null
    ? 'Trouble reaching WarCarp — trying again…'
    : 'Connection is taking longer than usual…'
}
